import CurrencyComponent from "@/components/currencyComponent";
import ButtonUI from "@/componentsUI/Button";
import InputUI from "@/componentsUI/Input";
import SelectUI, { SelectOption } from "@/componentsUI/Select";
import React, { useRef } from 'react'
import './index.less'
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import { AmountDivisorConversion } from "@/Core/utils/currencyDealCenter";

const ExchangeTransfer = (props) => {
    const { t } = useTranslationPlus('Wallet');
    const { value, onChange, onChangeSelect, wallets ,disabled ,onValueChange , showBtnMax} = props

    const ref= useRef(null)
    function handleChange(v) {
        onChange && onChange(v);
    }

    function findWalletBySelect(select){
        for(let i = 0 ; i < wallets?.length ; ++i) {
            if(select === wallets[i].currencyType) {
                return wallets[i]
            }
        }
    }

    return (
        <div className='exchange-transfer-out' ref={ref}>
            <InputUI
                //triggerDisabled={disabled}
                disabled={disabled}
                maxLength={10}
                value={value?.amount}
                onChange={(v)=>{
                    handleChange({
                        ...value,
                        amount: v,
                    })
                    onValueChange && onValueChange(v)
                }}
                onFocus={()=>{
                    ref.current.className = 'exchange-transfer-out exchange-transfer-out-focus'
                }}
                onBlur={()=>{
                    ref.current.className = 'exchange-transfer-out'
                }}
                addBefore={
                    <SelectUI
                        value={value?.select}
                        onChange={(v) => {
                            handleChange({
                                amount: undefined,
                                select: v
                            })
                            onChangeSelect && onChangeSelect(findWalletBySelect(v))
                        }}
                    >
                        {
                            wallets?.map((item, index) => {
                                return <SelectOption
                                    className="exchange-transfer-out-option"
                                    key={index} value={item?.currencyType} >
                                        <CurrencyComponent
                                            currencyType={item?.currencyType}
                                            serverCurrencyType={item?.serverCurrencyType}
                                        />
                                </SelectOption>
                            })
                        }
                    </SelectUI>
                }
                addAfter={
                    showBtnMax && <ButtonUI onClick={()=>{
                        const wallet = findWalletBySelect(value?.select)
                        if(wallet) {
                            const amount =  AmountDivisorConversion(wallet?.balance, {
                                currencyType: wallet?.currencyType,
                                serverCurrencyType: wallet?.serverCurrencyType
                            });
                            handleChange({
                                ...value,
                                amount
                            })
                            onValueChange && onValueChange(amount)
                        }
                    }}>{t('Max')}</ButtonUI>
                }
            >
            </InputUI>
        </div>
    )
}


export default ExchangeTransfer
